<template>
  <div class="admin-panel">
    <div class="admin-panel-fixbox">
      <div class="admin-content">
        <router-view class="view"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class PageWithoutNavbar extends Vue {

}
export default PageWithoutNavbar;
</script>

<style scoped>
.nav-logo {
  display: flex;
  float: left;
  margin-left: 0.4rem;
  margin-top: 0.7rem;
  font-size: 1.4rem;
  letter-spacing: 0.15rem;
  color: #72737c;
}

.nav-toggle {
  height: 3.75rem;
  margin-right: 0;
  padding-right: .8rem;
  padding-left: .8rem;
  position: relative;
  cursor: pointer;
  text-align: left;
  background-color: transparent;
  font-size: .75rem;
  font-weight:700
}

.nav-toggle:focus, .nav-toggle:hover {
  outline: none;
}

.nav-toggle:after {
  content: "";
  width: 7px;
  height: 7px;
  border-right: .13rem solid;
  border-top: .13rem solid;
  transform: rotate(135deg);
  transition-property: transform, opacity, top;
  transition-duration: .05s;
  transition-timing-function: ease-in-out;
  position: absolute;
  top: calc(50% - 5.5px);
  right: 2px;
  opacity:.5
}

.nav-toggle.active:after {
  transform: rotate(-45deg);
  top: calc(50% - 2.5px);
}

.session-box {
  margin-top: 0.7rem;
  float: right;
  position: relative;
}

.session-box > a {
  text-decoration: none;
}
</style>
